import React from "react";
import { Users } from "lucide-react";
import { useLang } from "@/i18n";
import useContent from "@/hooks/useContent";
import { DarkPage, Reveal, SectionKicker, TestimonialFeed, FinalCta, IMG } from "@/components/marketing";

const COMM_KEYS = ["comm_1", "comm_2", "comm_3", "comm_4", "comm_5", "comm_6"];

export default function Community() {
  const { t } = useLang();
  const content = useContent();
  return (
    <DarkPage>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-14">
        <Reveal className="max-w-3xl mb-10">
          <SectionKicker><Users size={13} className="inline" /> {t("nav_community")}</SectionKicker>
          <h1 className="font-head font-black text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight mb-4">{t("comm_title")}</h1>
          <p className="text-zinc-300 text-lg">{t("comm_sub")}</p>
        </Reveal>
        <Reveal delay={0.1} className="grid sm:grid-cols-3 gap-4 mb-14">
          {IMG.community.map((src, i) => <img key={i} src={src} alt="community" className="rounded-3xl border border-white/10 w-full aspect-[4/3] object-cover object-center" />)}
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
          {COMM_KEYS.map((k, i) => (
            <Reveal key={k} delay={(i % 3) * 0.06} className="rounded-3xl border border-white/10 bg-white/5 p-6">
              <p className="text-zinc-200 leading-relaxed">“{t(k)}”</p>
            </Reveal>
          ))}
        </div>
        <TestimonialFeed testimonials={content?.testimonials || []} />
      </section>
      <FinalCta content={content} />
    </DarkPage>
  );
}
